export const DOMAIN_FORMS_CONFIG = "FORMS_CONFIG";
